import { Box, Stack } from "@mui/material";
import heroimage from "../../../../public/apply/apply-hero-1.webp";
import iphoneimage from "../../../../public/apply/apply-iphone.webp";
import { LandingContainerBanner } from "../LandingContainerBanner/LandingContainerBanner";
import NextImage from "next/image";

export function LandingApplyBanner({ src = heroimage.src, isDark = false }: { src?: string; isDark?: boolean }) {
  return (
    <Stack
      spacing={4}
      direction={"column"}
      mb={{
        xs: 4,
        sm: 4,
        md: 12,
      }}
    >
      <LandingContainerBanner src={src} isDark={isDark}>
        <Box
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
            },
            position: "absolute",
            right: 0,
            top: 52,
            width: "30%",
            height: "100%",
          }}
        >
          <NextImage draggable={false} fill objectFit="contain" alt="" src={iphoneimage.src} />
        </Box>
      </LandingContainerBanner>
    </Stack>
  );
}
